module.exports = __webpack_public_path__ + "static/img/anxunSlogn.627c527d.png";